import theme from 'shared/styles/theme';

export type Header = {
  HEADER_TEXT: string;
  SUBHEAD_TEXT: string;
  HEADER_HERO: string;
  HEADER_TEXTURE: string;
  HEADER_TEXT_COLOR: string;
  HEADER_BG_COLOR: string;
  HEADER_SUBHEAD_TEXT_COLOR: string;
  FORM_HEADER: string;
  HEADER_IMAGE: string;
};

export const REFERRAL = 'Referral';

export const SIGNUP_HEADER_EXPERIMENT_GROUPS = Object.freeze({
  CONTROL: 'Control',
  VARIANT_A: 'Test',
  VARIANT_B: 'Test 2',
  VARIANT_C: 'Test 3',
  VARIANT_D: 'Test 4',
});

export const SIGNUP_HEADER_VARIANT = Object.freeze({
  CONTROL: 'control',
  VARIANT_A: 'variant_a',
  VARIANT_B: 'variant_b',
  VARIANT_C: 'variant_c',
  VARIANT_D: 'variant_d',
});

export type SignupHeaderVariant =
  (typeof SIGNUP_HEADER_VARIANT)[keyof typeof SIGNUP_HEADER_VARIANT];

export const SIGNUP_HEADER_GROUP_VARIANTS: ReadonlyArray<
  readonly [string, SignupHeaderVariant]
> = [
  [SIGNUP_HEADER_EXPERIMENT_GROUPS.CONTROL, SIGNUP_HEADER_VARIANT.CONTROL],
  [SIGNUP_HEADER_EXPERIMENT_GROUPS.VARIANT_A, SIGNUP_HEADER_VARIANT.VARIANT_A],
  [SIGNUP_HEADER_EXPERIMENT_GROUPS.VARIANT_B, SIGNUP_HEADER_VARIANT.VARIANT_B],
  [SIGNUP_HEADER_EXPERIMENT_GROUPS.VARIANT_C, SIGNUP_HEADER_VARIANT.VARIANT_C],
  [SIGNUP_HEADER_EXPERIMENT_GROUPS.VARIANT_D, SIGNUP_HEADER_VARIANT.VARIANT_D],
];

export const BRAND_HEADER = {
  HEADER_TEXT: 'attribution.varo',
  SUBHEAD_TEXT: 'attribution.setUpFuture',
  HEADER_HERO: '',
  HEADER_TEXTURE: '',
  HEADER_TEXT_COLOR: theme.color.expressive.light,
  HEADER_BG_COLOR: theme.color.expressive.varoPurple,
  HEADER_SUBHEAD_TEXT_COLOR: theme.color.interactive.inverse,
  FORM_HEADER: '',
  HEADER_IMAGE: '',
};

export const ADVANCE_HEADER = {
  HEADER_TEXT: 'attribution.varo',
  SUBHEAD_TEXT: 'attribution.bankBorrow',
  HEADER_HERO: '',
  HEADER_TEXTURE: '',
  HEADER_TEXT_COLOR: theme.color.expressive.light,
  HEADER_BG_COLOR: theme.color.expressive.varoPurple,
  HEADER_SUBHEAD_TEXT_COLOR: theme.color.interactive.inverse,
  FORM_HEADER: '',
  HEADER_IMAGE: '',
};

export const SAVING_HEADER = {
  HEADER_TEXT: 'attribution.varo',
  SUBHEAD_TEXT: 'attribution.letGetStarted',
  HEADER_HERO: '',
  HEADER_TEXTURE: '',
  HEADER_TEXT_COLOR: theme.color.interactive.inverse,
  HEADER_BG_COLOR: theme.color.expressive.varoPurple,
  HEADER_SUBHEAD_TEXT_COLOR: theme.color.interactive.inverse,
  FORM_HEADER: '',
  HEADER_IMAGE: '',
};

export const CHECKING_HEADER = {
  HEADER_TEXT: 'attribution.controlVariantHeader',
  HEADER_HERO: 'PHONE_A_ANIMATED',
  HEADER_TEXTURE: '',
  SUBHEAD_TEXT: '',
  HEADER_TEXT_COLOR: theme.color.expressive.varoPurple,
  HEADER_BG_COLOR: theme.color.expressive.sand,
  HEADER_SUBHEAD_TEXT_COLOR: '',
  FORM_HEADER: 'attribution.newKindOfBank',
  HEADER_IMAGE: '',
};

export const MULTI_STEP_INCENTIVE_HEADER = {
  HEADER_TEXT: 'attribution.titleJoin',
  SUBHEAD_TEXT: 'attribution.subTitleJoin',
  HEADER_HERO: 'WALLET_A_ANIMATED',
  HEADER_TEXTURE: 'WALLET_A_ANIMATED',
  HEADER_TEXT_COLOR: theme.color.expressive.light,
  HEADER_BG_COLOR: theme.color.expressive.varoPurple,
  HEADER_SUBHEAD_TEXT_COLOR: theme.color.interactive.inverse,
  FORM_HEADER: '',
  HEADER_IMAGE: '',
};

export const ORGANIC_HEADER = {
  HEADER_TEXT: 'attribution.betterBanking',
  SUBHEAD_TEXT: 'attribution.joinBank',
  HEADER_HERO: '',
  HEADER_TEXTURE: '',
  HEADER_TEXT_COLOR: theme.color.expressive.varoPurple,
  HEADER_BG_COLOR: theme.color.expressive.orchid,
  HEADER_SUBHEAD_TEXT_COLOR: theme.color.text.primary,
  FORM_HEADER: '',
  HEADER_IMAGE: 'assets/images/signup/organic-header.png',
  DISCLOSURE_TEXT: '',
};

export const VARIANT_HEADER_IMAGE =
  'assets/images/signup/phone-card-header.png';

export const VARIANT_DISCLOSURE = 'header.variantDisclosure';

// Control is the unmodified organic header; the four treatment arms share one
// design and differ only in header and subhead copy.
export const VARIANT_A_HEADER = {
  ...ORGANIC_HEADER,
  HEADER_TEXT: 'header.variantAHeader',
  SUBHEAD_TEXT: 'header.variantASubhead',
  HEADER_IMAGE: VARIANT_HEADER_IMAGE,
  DISCLOSURE_TEXT: VARIANT_DISCLOSURE,
};

export const VARIANT_B_HEADER = {
  ...ORGANIC_HEADER,
  HEADER_TEXT: 'header.variantBHeader',
  SUBHEAD_TEXT: 'header.variantBSubhead',
  HEADER_IMAGE: VARIANT_HEADER_IMAGE,
  DISCLOSURE_TEXT: VARIANT_DISCLOSURE,
};

export const VARIANT_C_HEADER = {
  ...ORGANIC_HEADER,
  HEADER_TEXT: 'header.variantCHeader',
  SUBHEAD_TEXT: 'header.variantCSubhead',
  HEADER_IMAGE: VARIANT_HEADER_IMAGE,
};

export const VARIANT_D_HEADER = {
  ...ORGANIC_HEADER,
  HEADER_TEXT: 'header.variantDHeader',
  SUBHEAD_TEXT: 'header.variantDSubhead',
  HEADER_IMAGE: VARIANT_HEADER_IMAGE,
  DISCLOSURE_TEXT: VARIANT_DISCLOSURE,
};

export const SIGNUP_HEADER_VARIANT_HEADERS = Object.freeze({
  control: ORGANIC_HEADER,
  variant_a: VARIANT_A_HEADER,
  variant_b: VARIANT_B_HEADER,
  variant_c: VARIANT_C_HEADER,
  variant_d: VARIANT_D_HEADER,
});

export const OTP_CHARACTER_LENGTH = 6;

export const KEYBOARD_HEIGHT_FOR_TEXT_KEYPAD = 300;
export const KEYBOARD_HEIGHT_FOR_PHONE_KEYPAD = 250;

export const KEYBOARD_SCROLL_OFFSET_PHONE_NUMBER = 80;
export const KEYBOARD_SCROLL_OFFSET_EMAIL = 140;

export const LOGIN_SCREEN_TYPE = 'login';
export const PHONE_VERIFICATION_TYPE = 'phone';
export const EMAIL_VERIFICATION_TYPE = 'email';
export const DEVICE_VERIFICATION_TYPE = 'device';
